module.exports = __webpack_public_path__ + "static/media/suite4.6e6311c7.png";